import type { UnavailableProfileStyle } from "src/types";

export class UnavailableStylesError extends Error {
  public readonly unavailableStyles: UnavailableProfileStyle[];

  constructor(message: string, unavailableStyles: UnavailableProfileStyle[]) {
    super(message);
    this.name = "UnavailableStylesError";
    this.unavailableStyles = unavailableStyles;

    // Ensure instanceof checks work in transpiled environments.
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
